import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import UsersTable from 'components/settings/UsersTable'
import { rolesQuery, usersQuery, useUsers } from 'hooks/users'

export const Route = createFileRoute('/_auth/_admin/admin/users')({
  loader: async ({ context: { queryClient } }) => {
    return Promise.all([await queryClient.ensureQueryData(usersQuery), await queryClient.ensureQueryData(rolesQuery)])
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { data: users } = useUsers()

  return (
    <Stack gap="xl" mt="xl">
      <UsersTable data={users} />
    </Stack>
  )
}
